import React from 'react';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { Description as DocumentIcon, Add as AddIcon } from '@mui/icons-material';
import { PdfTemplate } from '../../../../../types';

interface SummaryCardProps {
  templates: PdfTemplate[];
  openAddDialog: () => void;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ templates, openAddDialog }) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <DocumentIcon color="primary" sx={{ fontSize: 40 }} />
          <Box>
            <Typography variant="h4">{templates.length}</Typography>
            <Typography variant="body2" color="text.secondary">
              Document Templates
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={openAddDialog}
          >
            Add Template
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
